<script>
import Vue from 'vue';
import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions,
} from 'vuex';
import StackedBarChart from '~/components/vue-nvd3/components/stacked_bar_chart';
import LoanVolumeChartMixin from '~/bundles/loan_report/mixins/loan_volume_chart';
import LoanTypesStackedBarChart from '~/components/vue-nvd3/mixins/loan_types_stacked_bar_chart';
import Panel from '~/components/panel/components/panel';
import { defaultLoansTableState } from '../../loan_report/store/state';

export default Vue.component('loan-volume-chart', {

    components: {
        StackedBarChart,
        Panel,
    },

    mixins: [LoanTypesStackedBarChart, LoanVolumeChartMixin],

    data() {
        return {
            formattedBarChart: [],
            reportType: 'funded',
        };
    },

    computed: {
        ...mapState('loanReport', {
            loans_loading: (state) => state.loans_loading,
            bar_chart: (state) => state.bar_chart,
            params: (state) => state.loans.params,
        }),

        ...mapGetters('loanReport', [
            'queryParams',
        ]),
    },

    watch: {
        bar_chart() {
            this.setBarChart();
        },
    },

    mounted() {
        this.updateParams(defaultLoansTableState());
        this.commitDefaultFundedFilter(this.params);
        this.commitDefaultPipelineFilter(this.params);

        this.getLoanFormData()
            .then(() => {
                this.resetFilterToDefault(this.reportType);
                this.$store.dispatch('loanReport/getLoanStats').then((response) => {
                    this.$store.commit('loanReport/updateLoanStats', response);
                });
            });
    },

    methods: {
        ...mapMutations('loanReport', {
            commitLoans: 'getLoans',
            commitfilter: 'commitFilter',
            commitDefaultPipelineFilter: 'commitDefaultPipelineFilter',
            commitDefaultFundedFilter: 'commitDefaultFundedFilter',
            resetFilterToDefault: 'resetFilterToDefault',
            updateParams: 'loans/updateParams',
        }),

        ...mapActions('loanReport', {
            getLoanFormData: 'getLoanFormData',
        }),
    },
});
</script>

<template>
    <div>
        <transition
            appear
            name="custom-classes-transition"
            enter-active-class="animated fadeInDown"
        >
            <panel
                title="Loan Volume"
                subtitle="(Funded Date)"
                :is-loading="loans_loading"
                body-class="ff-height-432"
            >
                <template slot="body">
                    <bar-chart
                        height="402px"
                        tick-format="currency"
                        x-axis-label="Months"
                        y-axis-label="Loan Volume"
                        :x-value-field="xAxisDateField"
                        y-value-field="loan_amount_sum"
                        :model="formattedBarChart"
                    />
                </template>
            </panel>
        </transition>
    </div>
</template>

<style>
    .ff-height-432 {
        height: 432px;
    }
</style>
